import * as ko from 'knockout';
import * as localisationHelper from "localisationHelper";

// Interfaces
import { IAgreementSelectorParams } from "Content/ts/Models/Shared/AgreementSelector/IAgreementSelectorParams";
import { IMembershipPriceModel } from 'Content/ts/Models/Join/Interfaces/IMembershipPrice';

import { SelectTwoWithChildren } from "Content/ts/Models/Shared/SelectTwo/selectTwoModels";

export const Deps = {
    LocalisationHelper: localisationHelper
}

export class AgreementSelectionBase {
    memberships: KnockoutObservableArray<SelectTwoWithChildren>;
    selectedMembershipPrice: KnockoutObservable<IMembershipPriceModel>;
    isLoading: KnockoutObservable<boolean>;
    defaultText: string;
    closeOnSelect: boolean;
    showLabel: KnockoutObservable<boolean>;
    externalIsPropertyRequired: KnockoutComputed<boolean>;
    externalIsSelectionDisabled: KnockoutComputed<boolean>;
    isSelectionDisabled: KnockoutComputed<boolean>;    

    allowAgreementClear: boolean;

    customMessages: {
        AgreementLabel: string,
        HelpText: string,
        LoadingAgreements: string,
        AgreementRequiredValidationMessage: string
    };

    constructor(params: IAgreementSelectorParams) {
        this.memberships = params.Memberships;
        this.selectedMembershipPrice = params.SelectedMembership;
        this.isLoading = params.IsLoading || ko.observable(false);
        this.defaultText = params.DefaultText;
        this.showLabel = params.ShowLabel != null ? ko.observable(params.ShowLabel) : ko.observable(true);
        this.allowAgreementClear = params.AllowAgreementClear != null ? params.AllowAgreementClear : true;
        this.externalIsPropertyRequired = params.ExternalIsPropertyRequired || ko.pureComputed(() => false);
        this.externalIsSelectionDisabled = params.ExternalIsSelectionDisabled || ko.pureComputed(() => false);

        this.closeOnSelect = true;

        this.computedMethods();
        this.retrieveCustomMessages();
    }

    private retrieveCustomMessages() {
        this.customMessages = {
            AgreementLabel: Deps.LocalisationHelper.getString('MembershipResources', 'Agreement'),
            LoadingAgreements: Deps.LocalisationHelper.getString('GenericResources', 'Loading'),
            HelpText: Deps.LocalisationHelper.getString('JoinResources', 'ChooseAgreement'),
            AgreementRequiredValidationMessage: Deps.LocalisationHelper.getString('MembershipResources', 'AgreementRequired')
        };
    }

    private computedMethods() {
        this.isSelectionDisabled = ko.pureComputed(() => {
            return this.externalIsSelectionDisabled() || this.isLoading();
        });
    };
}